import { QaiSegmentedBarGraphKind } from '@qai/ui';
import { SCORE_KIND, SCORE_KIND_THRESHOLDS } from './constants/reporting-dashboard/score-kind.constants';

export function getKindByPercentage(percentage: number): QaiSegmentedBarGraphKind {
  if (percentage < SCORE_KIND_THRESHOLDS.WARNING_MAX) return SCORE_KIND.WARNING;
  if (percentage < SCORE_KIND_THRESHOLDS.INFO_MAX) return SCORE_KIND.INFO;
  return SCORE_KIND.SUCCESS;
}
